'use client'
import { ComponentProps, useCallback, useState } from 'react';
import clsx from 'clsx';

import { Icon } from '@/stories/atoms/Icon/Icon';

import styles from './missing-image.module.css';

type MissingImageProps = ComponentProps<'div'> & {
  /** mini : icône seule (miniatures) ; large : page annonce */
  variant?: 'mini' | 'default' | 'large'
}

const iconSizes = {mini: 'lg', default: '2x', large: '3x'} as const

// image absente ou qui ne charge pas (comme le portail Ideeri) :
// décoratif, le contenu autour (titre, alt des autres images) porte l'information
export const MissingImage = ({variant = 'default', className, ...props}: MissingImageProps) => (
  <div className={clsx(styles.wrapper, styles[variant], className)} aria-hidden {...props}>
    <Icon icon='image-slash' size={iconSizes[variant]}/>
    {variant !== 'mini' && <p className={styles.text}>Pas d&apos;image disponible</p>}
  </div>
)

// image en erreur → afficher MissingImage à la place
export const useBrokenImage = () => {
  const [broken, setBroken] = useState(false)
  // erreur survenue avant l'hydratation (page statique) : onError n'est jamais appelé
  const ref = useCallback((img: HTMLImageElement | null) => {
    if (img?.complete && img.naturalWidth === 0) setBroken(true)
  }, [])

  return { broken, ref, onError: () => setBroken(true) }
}
